import { INFO_SCREEN_TYPES } from '@/utils/constants';

import thanks from './thanks';

export default {
  [INFO_SCREEN_TYPES.THANK_YOU]: thanks,
};
